var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "#233E20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.359 11.598H.786v-1.6h15.573a10.294 10.294 0 0 1-1.64-1.699 12.12 12.12 0 0 1-1.546-2.634c-.35-.826-.572-1.643-.572-2.277h1.6c0 .323.13.91.445 1.653.307.724.76 1.53 1.34 2.28 1.175 1.523 2.754 2.677 4.56 2.677v1.6c-1.806 0-3.385 1.153-4.56 2.676a10.525 10.525 0 0 0-1.34 2.28c-.314.743-.445 1.33-.445 1.654h-1.6c0-.635.223-1.452.572-2.277a12.12 12.12 0 0 1 1.546-2.635 10.29 10.29 0 0 1 1.64-1.698Z"
  })));
};
export default SvgArrow;